<div class="buttons__bar">
    <a class="link  helvetica-neue-regular-font cancel-link" (click)="refreshApplication(); cancel.emit();" [innerHTML]="referenceDataLabels.CancelId | localizeLabel"></a>
      <button [disabled]="isFieldDisabled" (click)="saveApplication()" class="primary-button"
        [innerHTML]="saveButtonLabel | localizeLabel">
      </button>
  </div>